/**
 * Code Page 850 encoding for Star thermal printers.
 *
 * ESC/POS printers expect CP850-encoded text, not UTF-8.
 * This module maps common French characters to their CP850
 * byte values and passes ASCII through unchanged.
 * Unknown characters are replaced with '?' (0x3F).
 */

const CP850_MAP: Record<string, number> = {
  'é': 0x82,
  'è': 0x8A,
  'ê': 0x88,
  'ë': 0x89,
  'à': 0x85,
  'â': 0x83,
  'ù': 0x97,
  'û': 0x96,
  'ü': 0x81,
  'ô': 0x93,
  'î': 0x8C,
  'ï': 0x8B,
  'ç': 0x87,
  'É': 0x90,
  'È': 0xD4,
  'Ê': 0xD2,
  'À': 0xB7,
  'Ç': 0x80,
  '€': 0xD5,
  '°': 0xF8,
  '«': 0xAE,
  '»': 0xAF,
};

export function encodeCP850(text: string): Uint8Array {
  const bytes: number[] = [];

  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    const code = ch.charCodeAt(0);

    // ASCII printable range passes through directly
    if (code >= 0x20 && code <= 0x7E) {
      bytes.push(code);
    } else if (ch in CP850_MAP) {
      bytes.push(CP850_MAP[ch]);
    } else {
      // Unknown character → '?'
      bytes.push(0x3F);
    }
  }

  return new Uint8Array(bytes);
}
